import React from "react";
import * as Styled from "./PageContent.styled";
import { PageContentProps } from "./types";

export const PageContent: React.FC<PageContentProps> = React.memo((props) => {
    return <Styled.PageContent>{props.children}</Styled.PageContent>;
});

PageContent.displayName = "PageContent";
